import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/src/components/akreditasi/Jumbotron.jsx");
import(/* webpackMode: "eager" */ "/app/src/components/dashboard/Footer/Footer.jsx")